import { gql } from 'graphql-tag';

export const GET_DEVICES = gql`
  query devices {
    devices {
      id
      name
      store {
        id
      }
      deviceProfile {
        id
        name
        isDefault
        autoRestartHour
        orderTypes {
          id
          name
          code
        }
        defaultOrderType {
          id
          name
          code
        }
        customerDisplay {
          brandColor
          theme
          idleScreen {
            logoUri
            mediaType
            assets {
              position
              uri
            }
          }
          cartScreen {
            logoUri
            mediaType
            assets {
              position
              uri
            }
          }
        }
      }
      customerDisplay {
        id
        name
        isPaired
        lastLoginAt
      }
      mode
      linkCdsToPayApp
      enableTap2PayEmbedded
      paymentTerminal {
        id
        uuid
      }
      tap2PayDisplaySettings {
        enableRotation
        nfcKioskPosition
        pinAlignment
      }
    }
  }
`;

export const UPDATE_DEVICE_PAYMENT_TERMINAL = gql`
  mutation updateDevicePaymentTerminal($input: UpdateDeviceInput!) {
    updateDevice(input: $input) {
      id
      paymentTerminal {
        id
        uuid
      }
    }
  }
`;
